import { useFilters } from "./useFilters";
import { CouponFilters } from "@/types/coupon/filter";

export function useCouponFilters(initialFilters: CouponFilters = {}) {
  const filterHook = useFilters<CouponFilters>(initialFilters);

  return filterHook;
}
